import formatDate from 'date-fns/format'
// TODO import date-fn locales for other languages (see shared-components for how we do this in clients)
import enUs from 'date-fns/locale/en-US'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import { translations as client_translations } from './utilities/client-components'

i18next.use(initReactI18next).init({
  interpolation: {
    escapeValue: false, // React already does escaping
    format: (value, format) => {
      // If we need more formatting functions, check here: https://www.i18next.com/translation-function/formatting
      if (value instanceof Date) {
        // Formats: https://date-fns.org/v2.16.1/docs/format
        return formatDate(value, format || 'MM/dd/yyyy', {
          locale: enUs
        })
      }

      return value
    }
  },
  lng: 'en-US',
  ns: ['client'],
  resources: {
    // TODO Use other languages, see the clients project for how we assemble the resources for other languages
    'en-US': {
      // "client" is the namespace used by client-components
      client: client_translations['en-US']
    }
  },
  fallbackLng: 'en-US'
})
